import { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Link } from 'react-router-dom';
import Loader from './Loader';
import './Header.css';

const navLinks = [
  { label: 'Home', path: '/' },
  { label: 'Services', path: '/services' },
  { label: 'Internships', path: '/intern' },
  { label: 'Projects', path: '/portfolio' },
  { label: 'About', path: '/about' },
  { label: 'Contact Us', path: '/contactus' },
];

function Header() {
  const [loading, setLoading] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    setLoading(false);
  }, []);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  const handleNavigation = (path) => {
    setLoading(true);
    setTimeout(() => {
      navigate(path);
      setLoading(false);
    }, 800);
  };

  return (
    <>
      <header className={`site-header${scrolled ? ' scrolled' : ''}`}>
        <div className="header-inner">
          <Link to="/" className="header-logo">
            <img
              src="https://i.postimg.cc/7L5WS7qQ/Screenshot-2024-05-06-125647-removebg-preview.png"
              alt="Codeedex"
            />
          </Link>

          <nav className={`header-nav${menuOpen ? ' open' : ''}`}>
            {navLinks.map(({ label, path }) => (
              <button
                key={path}
                className={`nav-item${location.pathname === path ? ' active' : ''}`}
                onClick={() => handleNavigation(path)}
              >
                {label}
              </button>
            ))}
            <button
              className="nav-cta"
              onClick={() => handleNavigation('/contactus')}
            >
              Get Started
            </button>
          </nav>

          <button
            className={`hamburger${menuOpen ? ' open' : ''}`}
            onClick={() => setMenuOpen((o) => !o)}
            aria-label="Toggle menu"
          >
            <span />
            <span />
            <span />
          </button>
        </div>
      </header>

      {loading && <Loader />}
    </>
  );
}

export default Header;
